<div class="automatic-result" *ngIf="hasVisiblePanel" #exportContainer>
  <div class="automatic-result__header">
    <div>
      <div class="automatic-result__eyebrow">Автоматическое распределение</div>
      <h2 class="automatic-result__title">
        {{ screenTitle }}
        <span *ngIf="titleDate">на {{ titleDate }}</span>
      </h2>
      <div class="automatic-result__subtitle">{{ screenSubtitle }}</div>
    </div>
    <div class="automatic-result__actions">
      <button
        class="button automatic-result__save-button"
        type="button"
        *ngIf="showSaveDistributionButton"
        (click)="saveDistribution()"
        [disabled]="isSaveDistributionDisabled"
      >
        {{ automaticDistribution.isSavingResult ? 'Сохраняем...' : 'Сохранить распределение' }}
      </button>
      <button
        class="button automatic-result__save-button"
        type="button"
        (click)="openExportFormatModal()"
        [disabled]="isSaveResultDisabled"
      >
        Экспортировать результат
      </button>
    </div>
  </div>

  <div
    class="automatic-result__applied-status"
    [class.automatic-result__applied-status--saved]="isResultApplied"
    *ngIf="hasResultAppliedStatus"
  >
    {{ isResultApplied ? 'РЕЗУЛЬТАТ СОХРАНЕН' : 'РЕЗУЛЬТАТ НЕ СОХРАНЕН' }}
  </div>

  <app-message [type]="'success'" *ngIf="automaticDistribution.saveResultSuccess">
    <div message-content>Распределение сохранено.</div>
  </app-message>

  <app-message [type]="'error'" *ngIf="automaticDistribution.saveResultError">
    <div message-content>{{ automaticDistribution.saveResultError }}</div>
  </app-message>

  <app-message [type]="'error'" *ngIf="exportResultError">
    <div message-content>{{ exportResultError }}</div>
  </app-message>

  <div class="automatic-result__loading" *ngIf="automaticDistribution.resultLoading">
    <app-loader [position]="'reset'"></app-loader>
  </div>

  <app-message [type]="'error'" *ngIf="!automaticDistribution.resultLoading && automaticDistribution.resultError">
    <div message-content>
      <span>{{ automaticDistribution.resultError }}</span>
    </div>
  </app-message>

  <ng-container *ngIf="!automaticDistribution.resultLoading && !automaticDistribution.resultError">
    <div class="automatic-result__empty" *ngIf="!result">Результат автоматического распределения отсутствует.</div>

    <ng-container *ngIf="result">
      <section class="automatic-result__section" *ngIf="!hasDistributionData && automaticDistribution.showMap">
        <app-automatic-distribution-map-new [isEmployeeGph]="routeGphResolver" [result]="result" [tickets]="tickets"></app-automatic-distribution-map-new>
      </section>

      <div class="automatic-result__notice automatic-result__notice--empty" *ngIf="!hasDistributionData && !automaticDistribution.showMap">
        {{ emptyResultText }}
      </div>

      <ng-container *ngIf="hasDistributionData">
      <div class="automatic-result__summary">
        <div class="automatic-result__summary-item">
          <span>Всего заявок</span>
          <strong>{{ totalOrdersCount }}</strong>
        </div>
        <div class="automatic-result__summary-item">
          <span>Распределено</span>
          <strong>{{ plannedOrdersCount }}</strong>
        </div>
        <div class="automatic-result__summary-item">
          <span>Не распределено</span>
          <strong>{{ unassignedOrdersCount }}</strong>
        </div>
        <div class="automatic-result__summary-item">
          <span>Время в пути, мин</span>
          <strong>{{ travelTimeMinutes }}</strong>
        </div>
        <div class="automatic-result__summary-item">
          <span>Дистанция</span>
          <strong>{{ formatDistance(travelDistanceMeters) }}</strong>
        </div>
        <div class="automatic-result__summary-item">
          <span>Резервная матрица</span>
          <strong>{{ fallbackMatrixText }}</strong>
        </div>
      </div>

      <section class="automatic-result__section" *ngIf="automaticDistribution.showMap">
        <app-automatic-distribution-map-new [isEmployeeGph]="routeGphResolver" [result]="result" [tickets]="tickets"></app-automatic-distribution-map-new>
      </section>

      <section class="automatic-result__section" *ngIf="automaticDistribution.showSchedule">
        <div class="automatic-result__loading" *ngIf="automaticDistribution.originalTicketsLoading">
          <app-loader [position]="'reset'"></app-loader>
        </div>
        <app-message [type]="'error'" *ngIf="!automaticDistribution.originalTicketsLoading && automaticDistribution.originalTicketsError">
          <div message-content>{{ automaticDistribution.originalTicketsError }}</div>
        </app-message>
        <app-automatic-distribution-schedule-new
          *ngIf="!automaticDistribution.originalTicketsLoading"
          [result]="result"
          [tickets]="tickets"
          [originalTickets]="automaticDistribution.originalTickets"
          [brigades]="brigades"
          [employees]="distributionEmployees"
        ></app-automatic-distribution-schedule-new>
      </section>

      <section class="automatic-result__routes" *ngIf="routes.length">
        <div class="automatic-result__section-title">Маршруты сотрудников</div>

        <div
          class="automatic-result__route"
          [class.automatic-result__route--trip]="isRouteEmployeeOnTrip(route)"
          [class.automatic-result__route--gph]="isRouteEmployeeGph(route)"
          *ngFor="let route of routes; trackBy: trackByRoute"
        >
          <div class="automatic-result__route-header">
            <div>
              <div class="automatic-result__route-name">
                <span>{{ route.employee_name || 'Сотрудник' }}</span>
                <span class="automatic-result__employee-badge automatic-result__employee-badge--trip" *ngIf="isRouteEmployeeOnTrip(route)">
                  Командирован
                </span>
                <span class="automatic-result__employee-badge automatic-result__employee-badge--gph" *ngIf="isRouteEmployeeGph(route)">
                  ГПХ
                </span>
                <span class="automatic-result__route-transport">
                  <app-icon
                    [glyph]="getRouteTransportIcon(route)"
                    [size]="'18'"
                    [attr.title]="getRouteTransportTitle(route)"
                  ></app-icon>
                </span>
              </div>
              <div class="automatic-result__route-time">
                {{ formatDateTime(route.start_of_shift || route.route_start_time) }} -
                {{ formatDateTime(route.end_of_shift || route.route_end_time) }}
              </div>
            </div>
            <div class="automatic-result__route-count">Заявок: {{ route.total_orders || getRouteOrders(route).length }}</div>
          </div>

          <div class="automatic-result__table-wrap" *ngIf="getRouteOrders(route).length">
            <table class="automatic-result__table">
              <thead>
                <tr>
                  <th>№</th>
                  <th>Номер заявки</th>
                  <th>Заявка</th>
                  <th>Подтип заявки</th>
                  <th>Район</th>
                  <th>Адрес</th>
                  <th>Слот HD</th>
                  <th>Прибытие</th>
                  <th>Начало работ</th>
                  <th>Завершение работ</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let order of getRouteOrders(route); let index = index; trackBy: trackByOrder">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <ng-container *ngIf="getOrderLink(order) as orderLink; else routeOrderNumber">
                      <a [routerLink]="orderLink" [title]="'Открыть заявку № ' + getOrderNumber(order)">
                        {{ getOrderNumber(order) }}
                      </a>
                    </ng-container>
                    <ng-template #routeOrderNumber>{{ getOrderNumber(order) }}</ng-template>
                  </td>
                  <td>
                    {{ order.order_name || 'Заявка' }}
                    <app-icon
                      *ngIf="isOrderMoveAddr(order)"
                      [glyph]="'autotrack'"
                      [size]="'16'"
                      [color]="'gray-dark'"
                      [class]="'icon--va-middle'"
                      [attr.title]="'Переезд'"
                    ></app-icon>
                  </td>
                  <td class="automatic-result__table-subtype" [title]="getOrderSubtype(order)">{{ getOrderSubtype(order) }}</td>
                  <td>{{ getOrderDistrict(order) || '-' }}</td>
                  <td>{{ getOrderAddress(order) }}</td>
                  <td>{{ getOrderHdSlot(order) }}</td>
                  <td>{{ formatDateTime(order.arrival_time) }}</td>
                  <td>{{ formatDateTime(order.work_start_time) }}</td>
                  <td>{{ formatDateTime(order.work_end_time) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <div class="automatic-result__notice automatic-result__notice--success" *ngIf="hasSuccessfulDistribution">
        Все заявки успешно распределены.
      </div>

      <div class="automatic-result__notice automatic-result__notice--empty" *ngIf="!hasSuccessfulDistribution && !unassignedOrders.length">
        В результате нет нераспределенных заявок, но маршруты для отображения не найдены.
      </div>

      <section
        class="automatic-result__notice automatic-result__notice--analysis"
        *ngIf="automaticDistribution.analysisLoading || automaticDistribution.analysisError || unassignedAnalysis.length"
      >
        <div class="automatic-result__section-title">AI-анализ нераспределенных заявок</div>

        <div class="automatic-result__loading" *ngIf="automaticDistribution.analysisLoading">
          <app-loader [position]="'reset'"></app-loader>
          <div>AI-анализ выполняется...</div>
        </div>

        <app-message [type]="'error'" *ngIf="!automaticDistribution.analysisLoading && automaticDistribution.analysisError">
          <div message-content>
            <span>{{ automaticDistribution.analysisError }}</span>
          </div>
        </app-message>

        <div
          class="automatic-result__analysis"
          *ngFor="let analysis of unassignedAnalysis; trackBy: trackByAnalysis"
        >
          <div class="automatic-result__analysis-header">
            <ng-container *ngIf="getOrderLink(analysis) as analysisOrderLink; else analysisTitle">
              <a
                class="automatic-result__analysis-link"
                [routerLink]="analysisOrderLink"
                [title]="'Открыть заявку № ' + getOrderNumber(analysis)"
              >
                {{ getAnalysisTitle(analysis) }}
              </a>
            </ng-container>
            <ng-template #analysisTitle>
              <strong>{{ getAnalysisTitle(analysis) }}</strong>
            </ng-template>

            <span class="automatic-result__analysis-order" *ngIf="getAnalysisOrderInfo(analysis) as analysisOrderInfo">
              <span class="automatic-result__analysis-order-type" *ngIf="analysisOrderInfo.type">
                {{ analysisOrderInfo.type }}
              </span>
              <span *ngIf="analysisOrderInfo.subtype">
                Подтип: {{ analysisOrderInfo.subtype }}
              </span>
              <span *ngIf="analysisOrderInfo.hdSlot">
                Слот HD: {{ analysisOrderInfo.hdSlot }}
              </span>
              <span class="automatic-result__analysis-order-district" *ngIf="analysisOrderInfo.district">
                {{ analysisOrderInfo.district }}
              </span>
              <span
                class="automatic-result__analysis-order-address"
                *ngIf="analysisOrderInfo.address"
                [title]="analysisOrderInfo.address"
              >
                {{ analysisOrderInfo.address }}
              </span>
            </span>
          </div>
          <div *ngIf="analysis.summary">{{ formatAnalysisText(analysis.summary, analysis) }}</div>

          <div *ngIf="analysis.reasons && analysis.reasons.length">
            <div class="automatic-result__analysis-label">Причины</div>
            <ul>
              <li *ngFor="let reason of analysis.reasons">{{ formatAnalysisText(reason, analysis) }}</li>
            </ul>
          </div>

          <div *ngIf="getAnalysisRecommendations(analysis) as recommendations">
            <ng-container *ngIf="recommendations.length">
              <div class="automatic-result__analysis-label">Рекомендации</div>
              <ul>
                <li *ngFor="let recommendation of recommendations">{{ recommendation }}</li>
              </ul>
            </ng-container>
          </div>

          <div class="automatic-result__analysis-meta">
            <span *ngIf="getAnalysisSource(analysis)">Источник: {{ getAnalysisSource(analysis) }}</span>
            <span *ngIf="formatConfidence(analysis.confidence)">Уверенность: {{ formatConfidence(analysis.confidence) }}</span>
            <ng-container *ngIf="analysis.diagnostic_context as context">
              <span *ngIf="context.total_orders !== null && context.total_orders !== undefined">
                Всего заявок: {{ context.total_orders }}
              </span>
              <span *ngIf="context.unassigned_orders !== null && context.unassigned_orders !== undefined">
                Не распределено: {{ context.unassigned_orders }}
              </span>
              <span *ngIf="context.threshold_ratio !== null && context.threshold_ratio !== undefined">
                Порог: {{ formatThresholdRatio(context.threshold_ratio) }}
              </span>
              <span *ngIf="context.manual_analysis_required !== null && context.manual_analysis_required !== undefined">
                Требуется ручной анализ: {{ context.manual_analysis_required ? 'да' : 'нет' }}
              </span>
            </ng-container>
          </div>
        </div>
      </section>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-template #exportFormatModal let-modal>
  <div class="modal__header">
    <span class="title" id="automatic-result-export-title">Сохранение результата</span>
    <div class="modal-close color-gray-dark" (click)="modal.dismiss()"></div>
  </div>
  <div class="modal__body">
    <div class="automatic-result__export-description">Выберите формат сохраняемого файла.</div>
    <label
      class="automatic-result__export-option"
      [class.automatic-result__export-option--selected]="exportFormat === 'html'"
    >
      <input type="radio" name="automaticResultExportFormat" [checked]="exportFormat === 'html'" (change)="exportFormat = 'html'" />
      <span>
        <strong>HTML</strong>
        <small>Текущее представление карты или расписания.</small>
      </span>
    </label>
    <label
      class="automatic-result__export-option"
      [class.automatic-result__export-option--selected]="exportFormat === 'excel'"
    >
      <input type="radio" name="automaticResultExportFormat" [checked]="exportFormat === 'excel'" (change)="exportFormat = 'excel'" />
      <span>
        <strong>Excel</strong>
        <small>Полный результат: сводка, карта, расписание, маршруты, заявки и анализ.</small>
      </span>
    </label>
  </div>
  <div class="modal__footer">
    <div class="modal__footer-action">
      <button class="button" type="button" (click)="modal.close(exportFormat)">Сохранить</button>
    </div>
    <div class="modal__footer-action">
      <a class="link link--dotted-blue-dark" (click)="modal.dismiss()">Отмена</a>
    </div>
  </div>
</ng-template>
